import React from "react";
import { Flex } from "../../../Flex";
import { Span } from "../../../Span";
import { ContactDetailFields } from "../../../ContactDetailsForm/ContactDetailFields";
import { IconPopupTip } from "../../../IconPopupTip";
import { ContactDetailsContactPreferences } from "../../../ContactDetailsForm/ContactDetailsContactPreferences";
import { ContactDetailsValues } from "../../../../types/ContactDetailsValues";
import { MOBILE_REG_EXP } from "../../../../constants/ContactNumbersRegex";

interface Props {
  id: string;
  contactDetails: ContactDetailsValues;
  idPrefix: string;
  namePrefix: string;
  shouldDisableContactDetails?: boolean;
  emailPreferenceDisabled?: boolean;
  optionalEmail?: boolean;
  optionalMobile?: boolean;
}

export const DisconnectionContactDetailsRole: React.FC<Props> = ({
  id,
  contactDetails,
  idPrefix,
  namePrefix,
  emailPreferenceDisabled,
  optionalEmail,
  optionalMobile,
  shouldDisableContactDetails,
}) => {
  const focusable = true;
  const shouldDisableWorkEmailPreference =
    emailPreferenceDisabled || contactDetails.email === "";
  const shouldDisableWorkSmsPreference =
    !contactDetails.mobile || !MOBILE_REG_EXP.test(contactDetails.mobile);

  return (
    <Flex id={id} flexDirection="column">
      <ContactDetailFields
        focusable={focusable}
        idPrefix={idPrefix}
        namePrefix={namePrefix}
        optionalBusinessName
        optionalAlternatePhone
        optionalEmail={optionalEmail}
        optionalMobile={optionalMobile}
        disabledFirstName={shouldDisableContactDetails}
        disabledLastName={shouldDisableContactDetails}
        disabledEmail={shouldDisableContactDetails}
        disabledMobile={shouldDisableContactDetails}
        disabledAlternatePhone={shouldDisableContactDetails}
        disabledBusinessName={shouldDisableContactDetails}
      />

      <Flex
        flexDirection="row"
        mb={3}
        justifyContent={[
          "space-between",
          "space-between",
          "space-between",
          "flex-start",
        ]}
      >
        <Span fontSize={2} lineHeight={2} mr={3}>
          {"Select contact preferences"}
        </Span>
        <IconPopupTip icon="help" ml={["auto", "auto", 3]}>
          Select the preferred communication channel to receive job updates
        </IconPopupTip>
      </Flex>

      <ContactDetailsContactPreferences
        id={`${idPrefix}.workContactPreferences`}
        name={`${idPrefix}.workContactPreferences`}
        title="Work update:"
        emailLabel="Email"
        smsLabel="SMS"
        emailDisabled={shouldDisableWorkEmailPreference}
        smsDisabled={shouldDisableWorkSmsPreference}
        focusable={focusable}
      />
    </Flex>
  );
};
